import type { OperatorsSkill } from "../../operators";
import { Badge } from "../ui/badge";

export function SkillBadges(props: { skill: OperatorsSkill }) {
  const { skill } = props;
  return (
    <>
      {skill.builtin ? <Badge variant="info">Built-in</Badge> : null}
      {skill.locked ? <Badge variant="outline">Locked</Badge> : null}
      {skill.status === "disabled" ? <Badge variant="secondary">Disabled</Badge> : null}
      {skill.status === "archived" ? <Badge variant="secondary">Archived</Badge> : null}
      {skill.version ? <Badge variant="outline">v{skill.version}</Badge> : null}
    </>
  );
}
